import { useSnackBar } from './snackBar';
import { useI18n } from 'vue-i18n-bridge';
const copy = require('clipboard-copy');

export function useCopy() {
  const { show } = useSnackBar();
  const { t } = useI18n();

  const copyWithAlert = content => {
    let text = content;
    if (typeof content === 'object') {
      try {
        text = JSON.stringify(content, null, 2);
      } catch (e) {
        text = content;
      }
    }
    copy(text)
      .then(() => show(t('Copied successfully')))
      .catch(() => show("Can't copy"));
  };

  return {
    copy,
    copyWithAlert
  };
}
